export const PUBLICATION_LINK_TARGET = {
  LIBRARY_SYSTEM: "librarySystem",
  MANUAL: "manual",
} as const;
